import React from 'react';
import { useTranslation } from 'react-i18next';
import GlobalStringSettingPage from './GlobalStringSettingPage';

interface GlobalProjectSettingsSubjectPageProps {
  className?: string;
}

export const GlobalProjectSettingsSubjectPage: React.FC<
  GlobalProjectSettingsSubjectPageProps
> = (props) => {
  const { t } = useTranslation();
  return (
    <GlobalStringSettingPage
      className={props.className}
      settingType="emailSubject"
      title={t('settings:projectSettingsTable.title.subject')}
    />
  );
};

export default GlobalProjectSettingsSubjectPage;
